//#region INTERFACE IRetailGpEdit

/**
 * ### IRetailGpEdit
 * In-flight retail/GP edit captured per stock code in the Auto Ordering NGP Report modal.
 *
 * @interface IRetailGpEdit
 * @description Stores the user-entered retail (incl. VAT) and the derived gross profit
 *              percentage for an edited row, together with which of the two values was
 *              edited last. The "last edited" flag drives whether the partner value is
 *              recomputed from retail or from GP when subsequent calculations run.
 *
 * @property {number} gp - Gross profit percentage that corresponds to the current retail.
 * @property {'retail' | 'gp'} lastEdited - Field the user changed last, used to determine
 *              which side of the retail/GP pair drives recomputation.
 * @property {number} retail - Retail price including VAT entered (or derived) by the user.
 */
export interface IRetailGpEdit {
  gp: number;
  lastEdited: 'retail' | 'gp';
  retail: number;
}

//#endregion
